module.exports = __webpack_public_path__ + "static/media/IMG_1505.8dcf587b.JPG";